module.exports = __webpack_public_path__ + "img/img1.9310c741.png";